<template>
  <div>
    <transition name="bounce">
      <div class="bb-tax-inv-no-column"
           :class="{'bb-tax-inv-no-column_color': soa.isConsumed}"
           v-if="!soa.isAutoSoa && invoiceService"
      >
        {{numberSoa || ''}}
      </div>
      <div class="bb-tax-inv-no-column"
           v-else-if="soa.isMisc && !soa.isAutoSoa"
      >
        Bill to client
      </div>
      <div class="bb-tax-inv-no-column"
           v-else-if="soa.isNoPaymentInvoice && !soa.isAutoSoa"
      >
        Payment (no inv)
      </div>
      <div class="bb-tax-inv-no-column"
           v-else-if="soa.isOverPaidInvoice && !soa.isAutoSoa"
      >
        Overpaid
      </div>
    </transition>
    <div class="bb-tax-inv-no-column__tax-invoice" v-if="soa.isAutoSoa">
      <span>{{soa.invoice ? soa.invoice.taxInvoiceNumber : ''}}</span>
      <upload class="bb-table-body-upload__icon"
              v-if="soa.invoice && soa.invoice.uploadFile.length > 0"
              :popupDown="index !== soaList.soas.length -1"
              :files="soa.invoice.uploadFile || []"
              :item="soa"
              :view="soa.invoice && soa.invoice.uploadFile.length > 0"
              :upload="false"
              @view="openFile"/>
    </div>
  </div>
</template>

<script>
import Upload from '@/components/Main/Upload/Upload'
import {get} from 'lodash'
export default {
  name: 'TaxInvNoColumn',
  components: {Upload},
  props: ['checkedInvoice', 'soa', 'index', 'soaList'],
  computed: {
    numberSoa () {
      return get(this.soa, ['invoice', 'number'], '')
    },
    uploadFile () {
      return get(this.soa, ['invoice', 'uploadFile'], [])
    },
    invoiceService () {
      const value = get(this.soa, 'invoiceService', [])
      return Array.isArray(value) ? value.length : value
    }
  },
  methods: {
    openFile (file, item) {
      this.$emit('openFile', file, item)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../../sass/variables";
  @import "../../../../../../../../sass/mixins";
  .bb-tax-inv-no-column {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 6px;
    margin-left: -15px;
    background: rgba($color-accent, 0.14);
    color: $color-accent;
    border-radius: 4px;
    font-size: 13px;
    white-space: nowrap;
    cursor: pointer;
    transition: .3s;

    &_color {
      color: $color-japanese-laurel;
      background: rgba($color-japanese-laurel, 0.14);
    }

    &__tax-invoice {
      width: 100%;
      white-space: nowrap;
      display: grid;
      grid-template-columns: 1fr 21px 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/TaxInvNoColumn.vue